import { Rhythm } from '@trmediaab/zebra';
import { useSafeHtml } from '@trmediaab/zebra-hooks';
import { useTheme } from 'styled-components';
import merge from 'ts-deepmerge';

// TODO maybe?
//github.com/trmediaab/travronden-spel/blob/master/src/components/WysiwygText/transformHtml.js

interface Props
  extends Omit<React.ComponentPropsWithRef<typeof Rhythm>, 'children'> {
  html: string;
  variant?: string;
}

/**
 * A component that renders a string of HTML. The HTML is sanitized before being rendered.
 * The component extends Rhyhtm and can be used with all of its props.
 */
const Html = ({
  html,
  sx = {},
  variant = 'default',
  ...props
}: Props): React.JSX.Element => {
  const sanitizedHtml = useSafeHtml(html);
  const theme = useTheme();
  const styles = merge(
    {
      '*': {
        wordBreak: 'break-word',
      },
      '& .editor__fineprint': {
        display: 'block', // Fixes line-height
      },
    },
    theme.components.html.common || {},
    theme.components.html.variants[variant] || {},
    sx,
  );

  return (
    // Rule disabled because between should settable by the consumer
    // eslint-disable-next-line no-restricted-syntax
    <Rhythm
      dangerouslySetInnerHTML={{
        __html: sanitizedHtml,
      }}
      sx={styles}
      {...props}
    />
  );
};

export default Html;
